define('plugin/additional-fields/view/AdditionalFieldsView',['require','marionette','plugin/additional-fields/view/AdditionalFieldItemView'],function (require) {

    var Marionette = require('marionette');
    var AdditionalFieldItemView = require('plugin/additional-fields/view/AdditionalFieldItemView');

    return Marionette.CompositeView.extend({

        template: '#additional_fields_view',
        childViewContainer: '#sb_additional_fields',
        childView: AdditionalFieldItemView,

        _bookingModel: null,

        childEvents: {
            'change': 'updateBookingInfo'
        },
        collectionEvents: {
            'sync': 'updateBookingInfo'
        },

        initialize: function () {
            this._bookingModel = this.getOption('bookingModel');

            this.updateBookingInfo();
        },
        
        updateBookingInfo: function () {
            var additionalFields = {};
            var values = [];
            this.collection.each(function (model) {
                additionalFields[model.get('name')] = model.get('value');
                if (model.get('type') === 'cloud') {
                    additionalFields[model.get('name') + '_hash'] = model.get('filehash');
                }
                
                values.push({
                    'field_title': model.get('title'),
                    'field_type': model.get('type'),
                    'field_position': model.get('pos'),
                    'hash': model.get('type') === 'cloud' ? model.get('filehash') : undefined,
                    'value': model.get('value')
                });
            }, this);

            this._bookingModel.set('additional_fields', additionalFields);
            this._bookingModel.set('additional_fields_values', values);
        },

        childViewOptions: function () {
            return {
                'bookingModel': this._bookingModel
            };
        },
    });

});
